module.exports = __webpack_public_path__ + "static/img/strategy-loin.f2876585.png";